"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentStore__factory = void 0;
var _ethers = require("ethers");
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

class DocumentStore__factory extends _ethers.ContractFactory {
  constructor(signer) {
    super(_abi, _bytecode, signer);
  }
  deploy(_name, owner, overrides) {
    return super.deploy(_name, owner, overrides || {});
  }
  getDeployTransaction(_name, owner, overrides) {
    return super.getDeployTransaction(_name, owner, overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }
}
exports.DocumentStore__factory = DocumentStore__factory;
const _abi = [{
  inputs: [{
    internalType: "string",
    name: "_name",
    type: "string"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "DocumentIssued",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "DocumentRevoked",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint8",
    name: "version",
    type: "uint8"
  }],
  name: "Initialized",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "previousAdminRole",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "newAdminRole",
    type: "bytes32"
  }],
  name: "RoleAdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleRevoked",
  type: "event"
}, {
  inputs: [],
  name: "DEFAULT_ADMIN_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "ISSUER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "REVOKER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32[]",
    name: "documents",
    type: "bytes32[]"
  }],
  name: "bulkIssue",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32[]",
    name: "documents",
    type: "bytes32[]"
  }],
  name: "bulkRevoke",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "documentIssued",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "documentRevoked",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "getIssuedBlock",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleAdmin",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "grantRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "isIssued",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "blockNumber",
    type: "uint256"
  }],
  name: "isIssuedBefore",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "isRevoked",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "blockNumber",
    type: "uint256"
  }],
  name: "isRevokedBefore",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "issue",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "renounceRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "revoke",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "revokeRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "version",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}];
const _bytecode = "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";